export const transactionStatus = {
  approve: "business_payment_approve",
  cancel: "business_payment_cancel"
}